export default { USERS: 'https://jsonplaceholder.typicode.com/users' };


// WEBPACK FOOTER //
// ./src/constants/url-constant.js